import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Notification.css';
import { FaCheckCircle, FaUserPlus, FaComment, FaEnvelope } from 'react-icons/fa';
import { useNotifications } from './NotificationContext';

const Notification = () => {
  const { notifications, unreadCount, markAsRead, markAllAsRead, isLoading } = useNotifications();
  const [filter, setFilter] = useState('all');
  const navigate = useNavigate();

  // Check authentication on component mount
  useEffect(() => {
    const isAuthenticated = sessionStorage.getItem("token") && sessionStorage.getItem("user");
    
    if (!isAuthenticated) {
      navigate('/login', { 
        state: { 
          from: '/notifications', 
          message: 'You must be logged in to view your notifications' 
        } 
      });
    }
  }, [navigate]);

  // Filter notifications based on current filter
  const filteredNotifications = filter === 'all' 
    ? notifications 
    : filter === 'unread' 
      ? notifications.filter(notification => !notification.read) 
      : notifications.filter(notification => notification.type === filter);

  // Get icon based on notification type
  const getNotificationIcon = (type) => {
    switch (type) {
      case 'comment': return <FaComment className="notification-icon comment" />;
      case 'follow': return <FaUserPlus className="notification-icon follow" />;
      case 'message': return <FaEnvelope className="notification-icon message" />;
      default: return null;
    }
  };

  // Show loading state
  if (isLoading) {
    return (
      <div className="notifications-container">
        <div className="notifications-header">
          <h1>Notifications</h1>
        </div>
        <div className="notifications-loading">
          <p>Loading notifications...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="notifications-container">
      <div className="notifications-header">
        <h1>Notifications</h1>
        <div className="notifications-actions">
          <div className="filter-buttons">
            <button 
              className={filter === 'all' ? 'active' : ''} 
              onClick={() => setFilter('all')}
            >
              All
            </button>
            <button 
              className={filter === 'unread' ? 'active' : ''} 
              onClick={() => setFilter('unread')}
            >
              Unread ({unreadCount})
            </button>
            <button 
              className={filter === 'comment' ? 'active' : ''} 
              onClick={() => setFilter('comment')}
            >
              Comments
            </button>
            <button 
              className={filter === 'follow' ? 'active' : ''} 
              onClick={() => setFilter('follow')}
            >
              Follows
            </button>
            <button 
              className={filter === 'message' ? 'active' : ''} 
              onClick={() => setFilter('message')}
            >
              Messages
            </button>
          </div>
          <button 
            className="mark-all-read"
            onClick={markAllAsRead}
            disabled={unreadCount === 0}
          >
            Mark all as read
          </button>
        </div>
      </div>

      <div className="notifications-list">
        {filteredNotifications.length > 0 ? (
          filteredNotifications.map(notification => (
            <div 
              key={notification.id} 
              className={`notification-item ${notification.read ? 'read' : 'unread'}`}
              onClick={() => markAsRead(notification.id)}
            >
              <div className="notification-content">
                <div className="notification-avatar">
                  <img src={notification.image} alt={notification.user} />
                  {getNotificationIcon(notification.type)}
                </div>
                <div className="notification-text">
                  <p><strong>{notification.user}</strong> {notification.content}</p>
                  <span className="notification-time">{notification.timestamp}</span>
                </div>
              </div>
              {!notification.read && (
                <button 
                  className="mark-read-button" 
                  onClick={(e) => {
                    e.stopPropagation();
                    markAsRead(notification.id);
                  }}
                >
                  <FaCheckCircle />
                </button>
              )}
            </div>
          ))
        ) : (
          <div className="no-notifications">
            <p>No notifications to display</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Notification;